import React from "react";
import { Modal } from "../../../../shared/components/ui/Modal";
import { EditUserForm } from "../EditUserForm/EditUserForm";
import type { EditUserFormValues } from "../EditUserForm/EditUserForm";

interface EditUserModalProps {
  open: boolean;
  onClose: () => void;
  defaultValues: EditUserFormValues;
  onSubmit: (data: EditUserFormValues) => void;
  isSubmitting?: boolean;
  statusOptions: { value: string; label: string }[];
}

export const EditUserModal: React.FC<EditUserModalProps> = ({
  open,
  onClose,
  defaultValues,
  onSubmit,
  isSubmitting,
  statusOptions,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Editar Usuario"
      // slightly wider modal for more natural form layout
      size="lg"
      className="p-6 sm:p-8"
    >
      <EditUserForm
        defaultValues={defaultValues}
        onSubmit={onSubmit}
        onCancel={onClose}
        isSubmitting={isSubmitting}
        statusOptions={statusOptions}
      />
    </Modal>
  );
};

// Re-export the form values type for convenience
export type { EditUserFormValues };
